<template>
    <div class="w-full space-y-8" v-if="nonConformanceReport">
        <ui-header :title="`Non-Conformance Report #${nonConformanceReport.reference}`">
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Package">
                <template>{{ nonConformanceReport.packageName }}</template>
            </ui-data-grid-item>
            <ui-data-grid-item label="Title" wide>
                <template>{{ nonConformanceReport.title }}</template>
            </ui-data-grid-item>
            <ui-data-grid-item label="Date" wide>
                <template><span :class="nonConformanceReport.date?'':'text-gray-400'">{{
                        nonConformanceReport.date ? moment(nonConformanceReport.date).format('DD/MM/Y') : 'No Date Supplied'
                    }}</span></template>
            </ui-data-grid-item>
            <ui-data-grid-item label="Site Address" :value="nonConformanceReport.siteAddress"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="Contract Reference" :value="nonConformanceReport.contractReference" wide
            ></ui-data-grid-item>
            <ui-data-grid-item label="Location of Works" :value="nonConformanceReport.locationOfWorks" wide
            ></ui-data-grid-item>
            <ui-data-grid-item label="What is the main reason or what when wrong?"
                               :value="nonConformanceReport.whatWentWrong"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="Why doesn't the work meet specs?" :value="nonConformanceReport.whyNotMeetingSpec"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="What can be done to prevent it from happening again?"
                               :value="nonConformanceReport.whatToPrevent"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="Explanatory corrective action taken"
                               :value="nonConformanceReport.correctiveActionTaken"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="Key players involved in the NCR and specs affected under the NCR"
                               :value="nonConformanceReport.keyPlayers"
                               wide></ui-data-grid-item>
            <div :class="'lg:col-span-2'" v-if="nonConformanceReport.mediaUrl">
                <dt class="text-sm font-medium text-gray-500">
                    Media
                </dt>
                <dd class="mt-1 text-sm text-gray-900 w-full">
                    <img :src="nonConformanceReport.mediaPreviewUrl" style="max-width: 300px; max-height: 200px;"
                         v-if="isMimeTypeSupported(nonConformanceReport.mediaMimeType)">
                    <a :href="nonConformanceReport.mediaUrl" target="_blank"
                       v-text="nonConformanceReport.mediaName"></a>
                </dd>
            </div>
        </ui-data-grid>
    </div>
</template>

<script>

import moment from "moment";

export default {
    computed: {
        moment() {
            return moment
        }
    },
    components: {},
    props: {
        nonConformanceReport: Object,
    },
    data() {
        return {}
    },
    methods: {
        isMimeTypeSupported(mimeType) {
            return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/heic'].includes(mimeType.toLowerCase())
        },
    },
    async mounted() {
    }
}
</script>
